import _ from 'lodash';

import React from 'react';

import { Button, Table } from 'semantic-ui-react';

const OrdersTable = (props) => {
	const orders = props.orders;

	return (
		<Table basic="very" celled collapsing>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>Какой</Table.HeaderCell>
					<Table.HeaderCell>Тип</Table.HeaderCell>
					<Table.HeaderCell>Кол-во</Table.HeaderCell>
					<Table.HeaderCell>Цена</Table.HeaderCell>
					<Table.HeaderCell>ТП</Table.HeaderCell>
					<Table.HeaderCell>СЛ</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{_.map(orders, order => (
					<Table.Row key={order.orderId}>
						<Table.Cell key={`order_createType_cell_value`}>
							{order.createType}
						</Table.Cell>
						<Table.Cell key={`order_avg_cell_value`}>
							{order.orderType}
						</Table.Cell>
						<Table.Cell key={`order_qty_cell_value`}>
							{order.qty}
						</Table.Cell>
						<Table.Cell key={`order_vol_cell_value`}>
							{Number(order.price) || Number(order.triggerPrice)}
						</Table.Cell>
						<Table.Cell key={`order_tp_cell_value`}>
							$ {order.takeProfit}
						</Table.Cell>
						<Table.Cell key={`order_sl_cell_value`}>
							$ {order.stopLoss}
						</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	);
};

export default OrdersTable;
